import type { OutcomeToDisplay, Filter } from '../types';
import type { OutcomeParameterName } from '../../../types';

/*
 * Фильтрует исходы по значению форы для первой и второй команды
 * Создает пустые парные кэфы при их отсутствии (например, когда Ф1к +1 существует, Ф2к -1 не существует)
 */
export function filterHandicap(
    outcomes: OutcomeToDisplay[],
    filters: Map<OutcomeParameterName, Filter>,
): OutcomeToDisplay[] {
    const numericFilters = [...filters.values()]
        .filter((f) => f.kind === 'NUMERIC_PARAM_VALUE')
        .sort((a, b) => a.name.localeCompare(b.name));
    const filterTeam1 = numericFilters[0];
    const filterTeam2 = numericFilters[1];

    if (!filterTeam1 || !filterTeam2) {
        return outcomes;
    }

    /*
     * возможно, стоит перенести в билд для построения парных кэфов
     * при выводе всех исходов в виде таблицы фильтрация по значению форы не нужна
     * но нужно подготовить парные кэфы (найти отсутствующие кэфы)
     */

    const fValue = filterTeam1.activeValue.value;

    if (!fValue) {
        return outcomes;
    }

    const filteredOutcomes = [];

    for (const outcome of outcomes) {
        if (outcome.paramsMap.get(filterTeam1.name)?.has(fValue)) {
            filteredOutcomes.push(outcome);
            continue;
        }

        if (
            outcome.paramsMap
                .get(filterTeam2.name)
                ?.has((-parseFloat(fValue.replace(',', '.'))).toString())
        ) {
            filteredOutcomes.push(outcome);
        }
    }

    return filteredOutcomes;
}
